import React from "react";
import { Button } from "../Button";
import {
  IPropertyDetails,
  IPropertyResult,
  ContentType,
} from "@/interfaces/property";
import { getContent } from "@/lib/reactutils";
import Markdown from "react-markdown";

export const PropertyButtonsSecondary: React.FC<{
  property: IPropertyResult;
}> = ({ property }) => {
  if (!property || property.details.length === 0) return;
  const mainButtons = property.details.filter(
    (detail) => detail.size === "small",
  );
  if (mainButtons.length === 0) return;
  const buttons = []
    .concat(mainButtons)
    .sort((a, b) => a.order - b.order)
    .map((button: IPropertyDetails, index: number) => {
      const copyButton = button.contents as string;

      return (
        <Button
          type="overlay"
          key={button.order + index}
          buttonKey={button.order + index}
          button={button.name}
          bgColor="bg-secondary"
          overlayParagraphs={getContent(ContentType.BUTTON, button.contents)}
          paragraphWithCopyButton={{
            paragraph: <Markdown/>,
            copyValue: copyButton,
          }}
        />
      );
    });

  // const buttons = [
  //     { button: "Wifi", paragraphWithCopyButton: {
  //         paragraph: (
  //           <>
  //             <p className="mt-2">Wifi code:</p>
  //             <p>dE3aKdBR%8#cABEC!</p>
  //           </>
  //         ),
  //         copyValue: "dE3aKdBR%8#cABEC!"
  //     }},
  // ];

  return (
    <div
      id="SecondaryButtonsList"
      className="grid grid-cols-2 gap-[12px] w-full"
    >
      {buttons}
    </div>
  );
};
